import '../knockout-extensions';
import $ from 'jquery';

import {Dualbox} from '../dualbox';

var applicationListIsValid = true;


function remove_domain(value) {
    value = value.replace('https://pravoslavnoe-duhovenstvo.ru', '');
    value = value.replace('http://pravoslavnoe-duhovenstvo.ru', '');
    value = value.replace('https://priestdb-react.slcd.ru', '');
    value = value.replace('http://priestdb-react.slcd.ru', '');
    value = value.replace('http://localhost:8000', '');
    value = value.replace('http://127.0.0.1:8000', '');

    return value
}


var Person = function(parent, data, availableTypes) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.personId = ko.observable(data['personId']);
    self.personString = ko.observable(data['personString']);
    self.pages = ko.observable(data['pages']);
    self.type = ko.observable(data['type'] || availableTypes[0]['id']);
    self.display = ko.observable(data['display']);
    self.toDelete = ko.observable(false);

    self.idEnabled = ko.observable(true);
    self.stringEnabled = ko.observable(true);
    self.correctPersonId = ko.observable(true);

    if (self.personId()) {
        self.stringEnabled(false);
    } else {
        if (self.personString()){
            self.idEnabled(false);
        };
    };

    self.onBlurId = function (d, e) {
        self.getPersonById();
    };

    self.onChangeId = function (d, e) {
        if (e.keyCode === 13) {
            self.getPersonById();
        } else {
            self.correctPersonId(true);
            return true;
        };
    };

    self.personId.subscribe(function (newValue) {
        self.stringEnabled(!newValue);
        self.personString('');
    });

    self.personString.subscribe(function (newValue) {
        if (newValue) {
            self.idEnabled(!!self.personId());
        }
        else {
            self.idEnabled(true);
        };
    });

    self.getPersonById = function () {
        if (!self.personId()) {
            self.correctPersonId(true);
            self.personId(null);
            self.personString('');
            self.stringEnabled(true);
            return;
        }

        if (!isNaN(self.personId())) {
            $.ajax({
                url: '/cabinet/ajax/person/' + self.personId() + '/',
                success: function(data) {
                    self.personString(data.title);
                    self.correctPersonId(true);
                },
                async: false,
            }).fail(function () {
                self.personString('');
                self.correctPersonId(false);
            });
        } else self.correctPersonId(false);
    };

    self.isValidID = ko.computed(function () {
        return !self.personId() || self.correctPersonId();
    });

    self.parent = parent;
    self.availableTypes = availableTypes;

    self.dump = function() {
        return {
            id: self.id(),
            personId: self.personId(),
            personString: self.personString(),
            pages: self.pages(),
            type: self.type(),
            display: self.display(),
            toDelete: self.toDelete(),
        };
    };
};

var PersonList = function(person_formset) {
    var self = this;
    var availableTypes = [{id: -1, name: '--------'}].concat(person_formset['types']);

    self.persons = ko.observableArray(
        person_formset['persons'].map(function(p) {
            return new Person(self, p, availableTypes);
        })
    );
    self.addPerson = function() {
        self.persons.push(new Person(self, {display: true}, availableTypes));
    };
    self.dump = function() {
        return self.persons().map(function(p) {
            return p.dump();
        });
    };
};


var ProceedCity = function(parent, data, sections) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.proceedCityId = ko.observable(data['proceedCityId']);
    self.proceedCityString = ko.observable(data['proceedCityString']);
    self.pages = ko.observable(data['pages']);
    self.section = ko.observable(data['section'] || sections[0]['id']);
    self.isEditable = parent.isEditable;
    self.toDelete = ko.observable(false);

    if (self.isEditable) {
        self.idEnabled = ko.observable(true);
        self.stringEnabled = ko.observable(true);
    } else {
        self.idEnabled = ko.observable(false);
        self.stringEnabled = ko.observable(false);
    };

    self.correctProceedCityId = ko.observable(true);

    if (self.proceedCityId()) {
        self.stringEnabled(false);
    } else {
        if (self.proceedCityString()){
            self.idEnabled(false);
        };
    };

    self.onBlurId = function (d, e) {
        self.getProceedCityById();
    };

    self.onChangeId = function (d, e) {
        if (e.keyCode === 13) {
            self.getProceedCityById();
        } else {
            self.correctProceedCityId(true);
            return true;
        };
    };

    self.proceedCityId.subscribe(function (newValue) {
        self.stringEnabled(!newValue);
        self.proceedCityString('');
    });

    self.proceedCityString.subscribe(function (newValue) {
        if (newValue) {
            self.idEnabled(!!self.proceedCityId());
        }
        else {
            self.idEnabled(true);
        };
    });

    self.getProceedCityById = function () {
        if (!self.proceedCityId()) {
            self.correctProceedCityId(true);
            self.proceedCityId(null);
            self.proceedCityString('');
            self.stringEnabled(true);
            return;
        }

        if (!isNaN(self.proceedCityId())) {
            $.ajax({
                url: '/cabinet/ajax/proceed_city/' + self.proceedCityId() + '/',
                success: function(data) {
                    self.proceedCityString(data.fullname);
                    self.correctProceedCityId(true);
                },
                async: false,
            }).fail(function () {
                self.proceedCityString('');
                self.correctProceedCityId(false);
            });
        } else self.correctProceedCityId(false);
    };

    self.isValidID = ko.computed(function () {
        return !self.proceedCityId() || self.correctProceedCityId();
    });

    self.parent = parent;
    self.sections = sections;

    self.dump = function() {
        return {
            id: self.id(),
            proceedCityId: self.proceedCityId(),
            proceedCityString: self.proceedCityString(),
            pages: self.pages(),
            section: self.section(),
            toDelete: self.toDelete(),
        };
    };
};

var ProceedCityList = function(proceed_city_formset) {
    var self = this;
    var sections = [{id: -1, name: '--------'}].concat(proceed_city_formset['sections']);

    self.isEditable = proceed_city_formset['is_editable'];
    self.proceedCities = ko.observableArray(
        proceed_city_formset['proceed_cities'].map(function(p) {
            return new ProceedCity(self, p, sections);
        })
    );
    self.addProceedCity = function() {
        self.proceedCities.push(new ProceedCity(self, {}, sections));
    };
    self.dump = function() {
        return self.proceedCities().map(function(p) {
            return p.dump();
        });
    };
};


var Eparchy = function(parent, data) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.eparchyId = ko.observable(data['eparchyId']);
    self.eparchyString = ko.observable(data['eparchyString']);
    self.pages = ko.observable(data['pages']);
    self.isEditable = parent.isEditable;
    self.toDelete = ko.observable(false);

    if (self.isEditable) {
        self.idEnabled = ko.observable(true);
        self.stringEnabled = ko.observable(true);
    } else {
        self.idEnabled = ko.observable(false);
        self.stringEnabled = ko.observable(false);
    };

    self.correctEparchyId = ko.observable(true);

    if (self.eparchyId()) {
        self.stringEnabled(false);
    } else {
        if (self.eparchyString()){
            self.idEnabled(false);
        };
    };

    self.onBlurId = function (d, e) {
        self.getEparchyById();
    };

    self.onChangeId = function (d, e) {
        if (e.keyCode === 13) {
            self.getEparchyById();
        } else {
            self.correctEparchyId(true);
            return true;
        };
    };

    self.eparchyId.subscribe(function (newValue) {
        self.stringEnabled(!newValue);
        self.eparchyString('');
    });

    self.eparchyString.subscribe(function (newValue) {
        if (newValue) {
            self.idEnabled(!!self.eparchyId());
        }
        else {
            self.idEnabled(true);
        };
    });

    self.getEparchyById = function () {
        if (!self.eparchyId()) {
            self.correctEparchyId(true);
            self.eparchyId(null);
            self.eparchyString('');
            self.stringEnabled(true);
            return;
        }

        if (!isNaN(self.eparchyId())) {
            $.ajax({
                url: '/cabinet/ajax/summary_eparchy/' + self.eparchyId() + '/',
                success: function(data) {
                    self.eparchyString(data.title);
                    self.correctEparchyId(true);
                },
                async: false,
            }).fail(function () {
                self.eparchyString('');
                self.correctEparchyId(false);
            });
        } else self.correctEparchyId(false);
    };

    self.isValidID = ko.computed(function () {
        return !self.eparchyId() || self.correctEparchyId();
    });

    self.parent = parent;

    self.dump = function() {
        return {
            id: self.id(),
            eparchyId: self.eparchyId(),
            eparchyString: self.eparchyString(),
            pages: self.pages(),
            toDelete: self.toDelete(),
        };
    };
};

var EparchyList = function(summary_eparchy_formset) {
    var self = this;

    self.isEditable = summary_eparchy_formset['is_editable'];
    self.eparchies = ko.observableArray(
        summary_eparchy_formset['eparchies'].map(function(p) {
            return new Eparchy(self, p);
        })
    );
    self.addEparchy = function() {
        self.eparchies.push(new Eparchy(self, {}));
    };
    self.dump = function() {
        return self.eparchies().map(function(p) {
            return p.dump();
        });
    };
};


export function MaterialForm(person_formset, proceed_city_formset, summary_eparchy_formset) {
    var self = this;

    self.personList = ko.observable(new PersonList(person_formset));
    self.personListData = ko.observable();
    self.proceedCityList = ko.observable(new ProceedCityList(proceed_city_formset));
    self.proceedCityListData = ko.observable();
    self.eparchyList = ko.observable(new EparchyList(summary_eparchy_formset));
    self.eparchyListData = ko.observable();
    self.saveAction = ko.observable();
    self.saveLock = ko.observable(false);

    function checkInput(evt) {
        var item = evt.currentTarget;

        var isDelete = $(item)
            .closest('.form-group')
            .find('.delete-input')
            .is(':checked');

        var value = $(item).val();

        if(!isDelete){
            value = remove_domain(value);
            $(item).val(value);
        }
    }

    function attachChange() {
        $('.u-attachment-type')
            .find('select')
            .unbind()
            .change(attachBlur)
    }

    function attachBlur() {
        $('.u-attachment-field-link')
            .find('input')
            .unbind()
            .blur(checkInput)
    }

    $(attachBlur)

    self.reattachBlur = function(){
      setTimeout(function(){
          attachBlur();
          attachChange();
        }, 50);
    }

    self.save = function() {
        self.saveAction('save');
        self.preSave();
    };
    self.saveAndExit = function() {
        self.saveAction('save-and-exit');
        self.preSave();
    };

    self.preSave = function() {
        if (self.saveLock()) return;
        else self.saveLock(true);

        self.personListData(JSON.stringify(self.personList().dump()));
        self.proceedCityListData(JSON.stringify(self.proceedCityList().dump()));
        self.eparchyListData(JSON.stringify(self.eparchyList().dump()));

        var submitForm = function() {
            $('#material-form').submit();
        };

        var backToEdit = function() {
            $(this).dialog('close');
            self.saveLock(false);
        };

        if (
            self
                .personList()
                .persons()
                .some(function(p) {
                    if (p.toDelete()) {
                        return false;
                    }
                    return p.type() < 0;
                })
        ) {
            var dialog = $(
                '<p>Поле "Тип материала" у присоединяемой персоны должно быть заполнено</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });

            return;
        }

        if (
            self
                .personList()
                .persons()
                .some(function(p) {
                    if (p.toDelete()) return false;
                    return !p.personId() && !p.personString();
                })
        ) {
            var dialog = $(
                '<p>Поле "Персона" либо "Персона строкой" у присоединяемой персоны должно быть ' +
                    'заполнено</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });
            return;
        }

        if (
            self
                .personList()
                .persons()
                .some(function(p) {
                    return !p.correctPersonId() && !p.toDelete();
                })
        ) {
            var dialog = $(
                '<p>Проверьте правильность создания записи. Указан ID несуществующей персоны</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });
            return;
        }

        var wrongPersonPages = self
            .personList()
            .persons()
            .some(function(p) {
                if (p.toDelete() || !p.pages()) return false;

                var text = p.pages().toLowerCase();
                if (
                    text &&
                    !['С.', 'Стб.', 'Л.', '№', 'Т.', 'Ч.'].some(function(w) {
                        return text.indexOf(w.toLowerCase()) > -1;
                    })
                )
                    return true;

                return false;
            });

        if (wrongPersonPages) {
            var dialog = $(
                '<p>Поле "Страницы" у присоединяемой персоны должно содержать указание на страницы,' +
                    " листы, номера и др. с буквенными обозначениями ('С. 12', 'Л. 8–9об.', '№ 1. С. 5' и т. п.)." +
                    ' Вернуться к редактированию?</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Да, вернуться к редактированию': backToEdit,
                    'Нет, заполнить эти позиции позже': submitForm,
                },
                close: backToEdit,
            });
            return;
        }

        if (
            self
                .proceedCityList()
                .proceedCities()
                .some(function(p) {
                    if (p.toDelete()) {
                        return false;
                    }
                    return p.section() < 0;
                })
        ) {
            var dialog = $(
                '<p>Поле "Раздел" у присоединяемого населенного пункта должно быть заполнено</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });

            return;
        }

        if (
            self
                .proceedCityList()
                .proceedCities()
                .some(function(p) {
                    if (p.toDelete()) return false;
                    return !p.proceedCityId() && !p.proceedCityString();
                })
        ) {
            var dialog = $(
                '<p>Поле "Населенный пункт" либо "Населенный пункт строкой" у присоединяемого населенного пункта ' +
                    'должно быть заполнено</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });
            return;
        }

        if (
            self
                .proceedCityList()
                .proceedCities()
                .some(function(p) {
                    return !p.correctProceedCityId() && !p.toDelete();
                })
        ) {
            var dialog = $(
                '<p>Проверьте правильность создания записи. Указан ID несуществующего населенного пункта</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });
            return;
        }

        if (
            self
                .eparchyList()
                .eparchies()
                .some(function(p) {
                    if (p.toDelete()) return false;
                    return !p.eparchyId() && !p.eparchyString();
                })
        ) {
            var dialog = $(
                '<p>Поле "ID епархии" либо "Епархия строкой" у сводной страницы епархии ' +
                    'должно быть заполнено</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });
            return;
        }

        if (
            self
                .eparchyList()
                .eparchies()
                .some(function(p) {
                    return !p.correctEparchyId() && !p.toDelete();
                })
        ) {
            var dialog = $(
                '<p>Проверьте правильность создания записи. Указан ID несуществующей епархии</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });
            return;
        }


        /**
         * Проверка ссылки прикрепляемых приложений
         */
        var wrongLink = false;


        $('.u-attachment-field-link')
            .find('input')
            .each(function(item) {
                var isDelete = $(this)
                    .closest('.form-group')
                    .find('.delete-input')
                    .is(':checked');

                var value = $(this).val();

                if(!isDelete){
                    value = remove_domain(value);
                    $(this).val(value);
                }

                if (
                    !isDelete &&
                    value !== '' &&
                    value.indexOf('http://') < 0 &&
                    value.indexOf('https://') < 0 &&
                    value[0] !== '/'
                ) {
                    wrongLink = true;

                }
            });

        if (wrongLink) {
            $(
                '<p>Ссылка на приложение должна начинаться с <b>http://</b> или <b>https://</b></p>'
            ).dialog({
                closeText: null,
                buttons: [
                    {
                        text: 'Вернуться к редактированию',
                        click: backToEdit,
                    },
                ],
                minWidth: 400,
                modal: true,
            });
            return false;
        } else if (!wrongLink) {
            submitForm();
        }
    };
}

var Author = function(author) {
    var self = this;
    self.name = ko.observable(data['authorName']);
};

export function editMaterial(materialId) {
    $.post('/cabinet/material/edit/', {id: materialId}).done(function(data) {
        if (data['edited']) data = '<b class="text-success">' + data['edited_info'] + '</b>';
        else data = '<b class="text-danger">' + data['edited_info'] + '</b>';
        $('#u-edit-panel')
            .hide()
            .html(data)
            .fadeIn('fast');
    });
}

export function showMaterialHistory(url) {
    if (document.getElementById('historyView') && document.getElementById('historyView').checked)
        url = url + 'short/';
    window.open(url);
}

export function Material() {
    if (!$('.u-material-page').length) {
        return;
    }

    $(function() {
        $('#u-materialattachment-formset').on('change', '.u-attachment-type select', function() {
            var type = $(this).val();

            $(this)
                .parent()
                .parent()
                .parent()
                .find('.u-attachment-label')
                .hide();
            $(this)
                .parent()
                .parent()
                .find('.u-attachment-field')
                .hide();

            $(this)
                .parent()
                .parent()
                .parent()
                .find('.u-attachment-label-' + type)
                .show();
            var field = $(this)
                .parent()
                .parent()
                .find('.u-attachment-field-' + type);

            field.show();

            if (type == 'text') {
                tinyMCE.execCommand('mceAddEditor', false, field.find('textarea').attr('id'));
            }
        });

        $('.open-new-author-js').on('click', function(e) {
            // e.preventDefault();
            $(
                '<p>После добавления нового автора текущая страница должна быть перезагружена</p>'
            ).dialog({
                // dialogClass: "no-close",
                closeText: null,
                buttons: [
                    {
                        text: 'Сохранить текущие изменения и перезагрузить страницу',
                        click: function() {
                            $('.u-save-material').trigger('click');
                        },
                    },
                ],
                minWidth: 400,
                modal: true,
            });
        });

        Dualbox();
    });
}
